/* eslint-disable no-unused-expressions */
import emotionNormalize from 'emotion-normalize';
import { injectGlobal } from 'emotion';

injectGlobal`
  ${emotionNormalize}

  html {
    box-sizing: border-box;
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  body {
    background: hsl(0,0,0,97%);
    background: -moz-linear-gradient(top,  hsl(0,0%,96%) 0%, hsl(0,0%,97%) 100%);
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,hsl(0,0%,96%)), color-stop(100%,hsl(0,0%,97%)));
    background: -webkit-linear-gradient(top,  hsl(0,0%,96%) 0%,hsl(0,0%,97%) 100%);
    background: -o-linear-gradient(top,  hsl(0,0%,96%) 0%,hsl(0,0%,97%) 100%);
    background: -ms-linear-gradient(top,  hsl(0,0%,96%) 0%,hsl(0,0%,97%) 100%);
    background: linear-gradient(to bottom,  hsl(0,0%,96%) 0%,hsl(0,0%,97%) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='hsl(0,0%,96%)', endColorstr='hsl(0,0%,97%)',GradientType=0 );
    background-attachment: fixed;
    font-family: sans-serif;
    font-size: 17px;
    line-height: 1.6em;
    color: rgb(55, 55, 55);
    -webkit-font-smoothing: antialiased;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: sans-serif;
    line-height: 1.2em;
  }

  code {
    color: cornflowerblue;
  }

  a {
    color: red;
  }
`;



// WEBPACK FOOTER //
// ./src/styles/global.js